<template>
  <div class="data-screen">
    <div class="top-content">
      <div class="banner-wrapper">
        <div class="banner" @click.prevent="notifyFirst"><icon-ban :icon="icon" class=" show md:hidden lg:hidden" /></div>
        <div class="share">
          <facebook url="http://bid-salud-migrantes.netlify.app/hud.html" />
          <twitter url="http://bid-salud-migrantes.netlify.app/hud.html" />
        </div>
      </div>
      <slot />
    </div>
    <div class="buttons">
      <div class="btn-wrapper">
        <back @back="notifyBack" />
      </div>
      <div class="btn-wrapper">
        <a href="https://www.sciencedirect.com/science/article/pii/S2666623520300295" target="_blank"><download /></a>
      </div>
    </div>
  </div>
</template>
<script>
import Facebook from './Social/Facebook'
import Twitter from './Social/Twitter'
export default {
  components: { Facebook, Twitter },
  name: 'DataScreen',
  props: {
    icon: {
      type: String
    }
  },
  methods: {
    notifyBack () {
      this.$emit('back')
    },
    notifyFirst () {
      this.$emit('first')
    }
  }
}
</script>
